var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{directives:[{name:"wechat-title",rawName:"v-wechat-title",value:('最强蜗牛丨吃！吃的就是年夜饭！'),expression:"'最强蜗牛丨吃！吃的就是年夜饭！'"}]}),_vm._v(" "),_c('div',{directives:[{name:"show",rawName:"v-show",value:(_vm.pcShow),expression:"pcShow"}],staticClass:"pc-page"},[_c('div',{staticClass:"logo"}),_vm._v(" "),_c('div',{staticClass:"code"})])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-197b89f8","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/pages/snail/nyf/pc/index.vue
// module id = null
// module chunks = 